<template>
    <v-sheet style="background-color:#fafafa;height:100%">

        <v-toolbar floating elevation="0" style="border-bottom:1px solid #ddd" >
            <v-toolbar-title>{{page_title}}</v-toolbar-title>
        </v-toolbar>

        <v-container fill-height fluid>
            
            <v-layout justify-center wrap  align-center style="background-color:#fafafa;height:100%">              
                <v-flex xs12 md12 lg10 xl8 >
                    
                    <v-container grid-list-xl>
                         
                        <v-carousel
                            v-model="model"
                            :show-arrows="false"
                            hide-delimiter-background
                            hide-delimiters
                            height="100%"
                            light
                        >
                            <v-carousel-item>
                              
                                <v-layout wrap style="margin:12px">                                    
                                    <v-flex xs12 md6>
                                        
                                        <v-card class="px-2 py-2 mx-3 my-3">
                                            <v-simple-table>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left">Item</th>
                                                        <th class="text-left">Valor</th>
                                                        <th class="text-left">Quantidade</th>
                                                        <th class="text-left">Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="item in pedido" :key="item.id">
                                                        <td>{{ item.name }}</td>
                                                        <td>{{ formatarDinheiro(item.price) }}</td>
                                                        <td>{{ item.qty }}</td>
                                                        <td>{{ formatarDinheiro(item.qty * item.price) }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3">TOTAL</td>
                                                        <td>{{ formatarDinheiro(pedido_total) }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="2"></td>
                                                        <td colspan="2" align="center"><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; em até  {{parcelas[parcelas.length-1]}}x de {{formatarDinheiro( pedido_total/ parcelas[parcelas.length-1])}} </b> </td>
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </v-card>
                                    </v-flex>

                                    <v-flex xs12 md6>
                                        <v-btn
                                            class="mx-3 my-3"
                                            @click="mostrarPainelPagamento()"
                                            :loading="gerar_pedido_loading"
                                            v-if="!order_id && pedido.length"
                                            color="green"
                                            dark
                                        >Continuar</v-btn>
                                        <v-fade-transition>
                                            <v-card class="px-5 py-2 mx-3 my-3 " v-if="order_id">
                                                <v-card-title>Informações do cartão de crédito</v-card-title>
                                                <v-form>
                                                    <v-layout wrap class="px-5" >
                                                        <!--v-flex xs12 md5>
                                                    <v-select
                                                        :items="formaPagamento"
                                                        label="Forma de Pagamento"
                                                        v-model="cc.bandeira"
                                                        v-validate="'required'"
                                                        data-vv-name="bandeira"
                                                        :error-messages="errors.collect('bandeira')"
                                                        class="mt-5"
                                                    ></v-select>
                                                        </v-flex-->

                                                        <v-flex xs12 md12>
                                                            <v-text-field                                                            
                                                                class="purple-input"
                                                                label="Nome"
                                                                messages="Nome do titular exatamente como está no cartão."
                                                                v-model="cc.nome"
                                                                v-validate="'required'"
                                                                data-vv-name="nome"
                                                                :error-messages="errors.collect('nome')"
                                                            />
                                                        </v-flex>

                                                        <v-flex xs12 md12>
                                                            <v-text-field
                                                                v-model="cc.n_cc"
                                                                label="Número"
                                                                messages="Número do cartão de crédito"
                                                                v-validate="'required'"
                                                                data-vv-name="n_cc"
                                                                v-mask="'#### #### #### ####'"
                                                                :error-messages="errors.collect('n_cc')"
                                                            />
                                                        </v-flex>

                                                        <v-flex xs12 md5>

                                                             <v-select
                                                                    :items="cartao_meses"
                                                                    label="Mês"
                                                                    item-text="mes"
                                                                    item-value="num"  
                                                                    messages="Mês de expiração"

                                                                    v-model="cc.exp_m"    
                                                                    data-vv-name="exp_m"
                                                                    v-validate="'required'"
                                                                    :error-messages="errors.collect('exp_m')"                                                              

                                                                    >
                                                                     <template v-slot:item="{item}">
                                                                         {{item.num+" - "+item.mes}}
                                                                     </template> 

                                                                    </v-select>

                                                                    
                                                            <!--v-text-field
                                                                class="purple-input"
                                                                label="MM"
                                                                messages="Mês Validade"
                                                                v-model="cc.exp_m"
                                                                
                                                               
                                                               
                                                            /-->
                                                        </v-flex>

                                                        <v-flex xs12 md4>
                                                            <v-select
                                                                    :items="cartao_anos"
                                                                    label="Ano"  
                                                                    messages="Ano de expiração"

                                                                    v-model="cc.exp_y"
                                                                    v-validate="'required'"
                                                                    data-vv-name="exp_y"
                                                                    :error-messages="errors.collect('exp_y')"
                                                                    ></v-select>

                                                            <!--v-text-field
                                                                class="purple-input"
                                                                label="AAAA"
                                                                messages="Ano Validade"
                                                                v-model="cc.exp_y"
                                                                v-validate="'required|numeric|digits:4|min_value:2019'"
                                                                data-vv-name="exp_y"
                                                                :error-messages="errors.collect('exp_y')"
                                                            /-->
                                                        </v-flex>

                                                        <v-flex xs12 md3>
                                                            <v-text-field
                                                                class="purple-input"
                                                                label
                                                                messages="Código de segurança"
                                                                v-model="cc.cvv"
                                                                v-validate="'required|numeric|digits:3'"
                                                                data-vv-name="cvv"
                                                                :error-messages="errors.collect('cvv')"
                                                            />
                                                        </v-flex>

                                                        <v-flex xs12 md12 class="py-5">
                                                            <v-divider></v-divider>
                                                        </v-flex>

                                                        <v-flex xs4 md4 v-if="cc.parcelas">
                                                            <h3 class="text-left mt-3">Pagar em</h3>
                                                        </v-flex>

                                                        <v-flex xs3 md3>
                                                            <v-select
                                                                :items="parcelas"
                                                                label="Parcelas"
                                                                v-validate="'required'"
                                                                data-vv-name="parcelas"
                                                                :error-messages="errors.collect('parcelas')"
                                                                v-model="cc.parcelas"
                                                            ></v-select>
                                                        </v-flex>
                                                        <v-flex xs5 md5 v-if="cc.parcelas">
                                                            <h3
                                                                class="text-center mt-3"
                                                            >de {{formatarDinheiro( pedido_total/cc.parcelas)}}</h3>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-form>
                                                <v-card-actions>                                                   
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                        color="green"
                                                        dark
                                                        class="my-3"
                                                        @click="fazerPagamento"
                                                        elevation="0"
                                                        large
                                                    >ENVIAR PEDIDO</v-btn>

                                                    <!--v-btn
                                                color="red"
                                                dark
                                                class="my-3"
                                                @click="fazerPagamentoDireto"
                                                elevation="0"
                                                    >Fechar Pedido Direto</v-btn-->
                                                </v-card-actions>
                                            </v-card>
                                        </v-fade-transition>
                                    </v-flex>
                                </v-layout>
                            </v-carousel-item>

                            <v-carousel-item style="height:100%;">
                                <!--div class="align-left text-left">
                                    <v-btn
                                        :to="{path:'/dashboard/products'}"
                                        class="elevation-0"
                                        icon
                                    >
                                        <v-icon>mdi-arrow-left</v-icon>
                                    </v-btn>
                                </div-->

                                <v-card class="elevation-1 my-5 px-3">
                                    <v-card-title
                                        style="color:black; text-align:center!important;display:block"
                                        class="text-center align-center py-5"
                                    >Obrigado!</v-card-title>

                                    <v-card-text style="text-align:center!important;display:block">
                                        <p>
                                            Seu pagamento foi enviado! Estamos apenas aguardando a confirmação e logo seu produto será enviado para as plataformas.
                                            <br />Te manteremos informado por e-mail!
                                        </p>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                    </v-card-actions>
                                </v-card>
                            </v-carousel-item>
                        </v-carousel>
                    </v-container>
                </v-flex>

                <!--DIALOG -->
                <div class="text-xs-center">
                    <v-dialog v-model="dialog" width="500">
                        <v-card>
                            <v-card-title class="headline grey lighten-2" primary-title>{{mensagem}}</v-card-title>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" @click="dialog = false">OK</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </div>
            </v-layout>
        </v-container>
    </v-sheet>
</template>

<script>
import TopToolbar from "../../../components/shared/topbar.vue";
import PaymentService from "../../../app/Rest/payment";
import Vue from "vue";
import VeeValidate from "vee-validate";
import { money } from "../../../app/general";

import { mapGetters } from "vuex";

Vue.use(VeeValidate);

var paymentService = null;

var ccErrorNo = 0;
var ccErrors = new Array();
var _money = new money();

ccErrors[0] = "Tipo de cartão não aceito"; //"Unknown card type"
ccErrors[1] = "Número de cartão não fornecido"; //"No card number provided"
ccErrors[2] = "Número de cartão inválido"; //"Credit card number is in invalid format"
ccErrors[3] = "Número de cartão inválido"; //"Credit card number is invalid"
ccErrors[4] = "Verifique a quantidade de dígitos do seu cartão"; //"Credit card number has an inappropriate number of digits"
ccErrors[5] = "Número de cartão inválido"; //"Warning! This credit card number is associated with a scam attempt"

function checkCreditCard(cardnumber, cardname) {
    // Array to hold the permitted card characteristics
    var cards = new Array();

    // Define the cards we support. You may add addtional card types as follows.

    //  Name:         As in the selection box of the form - must be same as user's
    //  Length:       List of possible valid lengths of the card number for the card
    //  prefixes:     List of possible prefixes for the card
    //  checkdigit:   Boolean to say whether there is a check digit

    cards[0] = {
        name: "Visa",
        length: "13,16",
        prefixes: "4",
        checkdigit: true
    };
    cards[1] = {
        name: "Master",
        length: "16",
        prefixes: "51,52,53,54,55",
        checkdigit: true
    };

    // Establish card type
    var cardType = -1;
    for (var i = 0; i < cards.length; i++) {
        // See if it is this card (ignoring the case of the string)
        if (cardname == cards[i].name) {
            cardType = i;
            break;
        }
    }

    // If card type not found, report an error
    if (cardType == -1) {
        ccErrorNo = 0;
        return false;
    }

    // Ensure that the user has provided a credit card number
    if (cardnumber.length == 0) {
        ccErrorNo = 1;
        return false;
    }

    // Now remove any spaces from the credit card number
    cardnumber = cardnumber.replace(/\s/g, "");

    // Check that the number is numeric
    var cardNo = cardnumber;
    var cardexp = /^[0-9]{13,19}$/;
    if (!cardexp.exec(cardNo)) {
        ccErrorNo = 2;
        return false;
    }

    // Now check the modulus 10 check digit - if required
    if (cards[cardType].checkdigit) {
        var checksum = 0; // running checksum total
        var mychar = ""; // next char to process
        var j = 1; // takes value of 1 or 2

        // Process each digit one by one starting at the right
        var calc;
        for (i = cardNo.length - 1; i >= 0; i--) {
            // Extract the next digit and multiply by 1 or 2 on alternative digits.
            calc = Number(cardNo.charAt(i)) * j;

            // If the result is in two digits add 1 to the checksum total
            if (calc > 9) {
                checksum = checksum + 1;
                calc = calc - 10;
            }

            // Add the units element to the checksum total
            checksum = checksum + calc;

            // Switch the value of j
            if (j == 1) {
                j = 2;
            } else {
                j = 1;
            }
        }

        // All done - if checksum is divisible by 10, it is a valid modulus 10.
        // If not, report an error.
        if (checksum % 10 != 0) {
            ccErrorNo = 3;
            return false;
        }
    }

    // Check it's not a spam number
    if (cardNo == "5490997771092064") {
        ccErrorNo = 5;
        return false;
    }

    // The following are the card-specific checks we undertake.
    var LengthValid = false;
    var PrefixValid = false;
    var undefined;

    // We use these for holding the valid lengths and prefixes of a card type
    var prefix = new Array();
    var lengths = new Array();

    // Load an array with the valid prefixes for this card
    prefix = cards[cardType].prefixes.split(",");

    // Now see if any of them match what we have in the card number
    for (i = 0; i < prefix.length; i++) {
        var exp = new RegExp("^" + prefix[i]);
        if (exp.test(cardNo)) PrefixValid = true;
    }

    // If it isn't a valid prefix there's no point at looking at the length
    if (!PrefixValid) {
        ccErrorNo = 3;
        return false;
    }

    // See if the length is valid for this card
    lengths = cards[cardType].length.split(",");
    for (j = 0; j < lengths.length; j++) {
        if (cardNo.length == lengths[j]) LengthValid = true;
    }

    // See if all is OK by seeing if the length was valid. We only check the length if all else was
    // hunky dory.
    if (!LengthValid) {
        ccErrorNo = 4;
        return false;
    }

    // The credit card is in the required format.
    return true;
}

export default {
    components: {
        TopToolbar
    },
    $_veeValidate: {
        validator: "new"
    },

    computed: {
        ...mapGetters(["configs"]),
        page_title(){
            return this.order_id == null ? "CONFIRA O SEU PEDIDO" : "FINALIZE SEU PEDIDO"
        },
        cartao_anos(){
            let anos = [];
            for (let i=2019;i<=2033;i++){
                 anos.push(i);
            }
            return anos;
        }
    },

    data: () => ({
        cartao_meses:[
            {mes:'Janeiro', num:'01'},
            {mes:'Fevereiro', num:'02'},
            {mes:'Março', num:'03'},
            {mes:'Abril', num:'04'},
            {mes:'Maio', num:'05'},
            {mes:'Junho', num:'06'},
            {mes:'Julho', num:'07'},
            {mes:'Agosto', num:'08'},
            {mes:'Setembro', num:'09'},
            {mes:'Outubro', num:'10'},
            {mes:'Novembro', num:'11'},
            {mes:'Dezembro', num:'12'},
        ],
        activeBtn: 1,
        mensagem: null,
        cc: { parcelas: 1 },
        formaPagamento: ["Master", "Visa"],
        parcelas: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        pedido: [],
        pedido_total: 0,
        dictionary: {
            custom: {
                bandeira: {
                    required:
                        "É necessário selecionar a bandeira do cartão de crédito"
                },
                n_cc: {
                    required:
                        "Número do cartão de crédito é um campo obrigatório.",
                    numeric: "Esse campo deve conter apenas números"
                },
                exp_m: {
                    required:
                        "Mês de validade do cartão de crédito é um campo obrigatório.",
                    digits: "Esse campo deve ter dois dígitos",
                    numeric: "Esse campo deve conter apenas números"
                },
                exp_y: {
                    required:
                        "Ano de validade do cartão de crédito é um campo obrigatório.",
                    digits: "Esse campo deve ter quatro dígitos",
                    numeric: "Esse campo deve conter apenas números",
                    min_value: "Verifique a validade do seu cartão de crédito"
                },
                nome: {
                    required:
                        "Nome como impresso no cartão de crédito é um campo obrigatório."
                },
                cvv: {
                    required:
                        "Código de segurança CVV do cartão de crédito é um campo obrigatório",
                    digits: "Esse campo deve ter três dígitos",
                    numeric: "Esse campo deve conter apenas números"
                },
                parcelas: {
                    required: "Selecione em quantas vezes deseja pagar"
                }
            }
        },
        model: 0,
        dialog: false,
        //product
        product: {},
        order_id: 0,
        gerar_pedido_loading: false
        //fechar_pedido_loading:false
    }),

    mounted() {
        this.$validator.localize("ptbr", this.dictionary);
        this.product = this.$route.params.product;
        if (this.product.id) {
            paymentService.getServiceItems(this.product.id).then(e => {
                //this.tabula_pedido(e.items);
                this.pedido = e.items.items;
            }).finally(()=>{
                this.$store.commit("loading", false);
            });

            //getServiceItems
        }
    },

    created: function() {
        paymentService = new PaymentService();
    },
    watch: {
        cc: {
            handler() {
                this.cc.bandeira = this.cc.n_cc
                    ? this.cc.n_cc[0] == "4"
                        ? "Visa"
                        : "Master"
                    : null;
            },
            deep: true
        },
        //monitora a propriedade pedido e recaulcula o valor total
        pedido() {
            this.pedido.map(e => {
                this.pedido_total += e.qty * e.price;
            });
        }
    },

    methods: {
        gerarPedido() {},
        mostrarPainelPagamento() {
            this.gerar_pedido_loading = true;
            //sensação visual

            setTimeout(() => {
                this.gerar_pedido_loading = false;


                this.order_id = 1;
            }, 1000);
        },
        formatarDinheiro(valor) {
            return _money.formatWithCurrency(valor / 100, 2, ",");
        },
        fazerPagamentoDireto() {
            this.$store.commit("loading");
            let params = {};

            params.cc = this.cc;
            params.cc.n_cc = params.cc.n_cc.replace(" ","");
            params.product_id = this.product.id;

            paymentService
                .makePayment(params)
                .then(e => {
                    if (e.status == "ok") {
                        this.model = 1;
                        return;
                    }
                    this.mensagem = e.msg;
                    this.dialog = true;
                    //console.log("retorno do pagamento", e);
                })
                .catch(() => {
                    this.mensagem =
                        "Tivemos um problema na comunicação com os nossos servidores. Tente novamente em 5 minutos.";
                    this.dialog = true;
                })
                .finally(e => {
                     this.$store.commit("loading", false);
                });
        },
        fazerPagamento() {
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    return;
                }

                if (checkCreditCard(this.cc.n_cc, this.cc.bandeira)) {
                    this.$store.commit("loading");

                    let params = {};

                    params.cc = this.cc;                    
                    params.product_id = this.product.id;

                    paymentService
                        .makePayment(params)
                        .then(e => {
                            if (e.status == "ok") {
                                this.model = 1;
                                return;
                            }
                            this.mensagem = e.msg;
                            this.dialog = true;
                            //console.log("retorno do pagamento", e);
                        })
                        .catch(() => {
                            this.mensagem =
                                "Tivemos um problema na comunicação com os nossos servidores. Tente novamente em 5 minutos.";
                            this.dialog = true;
                        })
                        .finally(e => {
                             this.$store.commit("loading", false);
                        });
                } else {
                    //console.log(ccErrors[ccErrorNo]);
                    this.dialog = true;
                    this.mensagem = ccErrors[ccErrorNo];
                }
            });
        }
    }
};
</script>